import { ExistsCompareOperators } from "@redotech/redo-customer-segments-common/segments/segment-where-condition";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";

/**
 * Lets a filter offer "is set" / "is not set" alongside its own operators.
 * Only custom fields support presence, so other dimensions omit this prop.
 */
export interface PresenceOperators {
  /** Set when the condition is currently a presence check. */
  operator?: ExistsCompareOperators;
  setOperator: (operator: ExistsCompareOperators) => void;
}

export const presenceOperatorItems: RedoListItem<ExistsCompareOperators>[] = [
  {
    id: ExistsCompareOperators.SET,
    type: "text",
    value: ExistsCompareOperators.SET,
    text: "is set",
  },
  {
    id: ExistsCompareOperators.NOT_SET,
    type: "text",
    value: ExistsCompareOperators.NOT_SET,
    text: "is not set",
  },
];

const presenceOperatorValues: unknown[] = Object.values(ExistsCompareOperators);

export function isPresenceOperator(
  value: unknown,
): value is ExistsCompareOperators {
  return presenceOperatorValues.includes(value);
}

export function PresenceAwareOperatorSelect<TOperator>({
  operatorItems,
  operator,
  setOperator,
  presence,
}: {
  operatorItems: RedoListItem<TOperator>[];
  operator: TOperator;
  setOperator: (operator: TOperator) => void;
  presence?: PresenceOperators;
}) {
  const options: RedoListItem<TOperator | ExistsCompareOperators>[] = presence
    ? [...operatorItems, ...presenceOperatorItems]
    : operatorItems;

  return (
    <RedoSingleSelectDropdownInput<TOperator | ExistsCompareOperators>
      fitToAnchor={false}
      flexGrow={false}
      options={options}
      optionSelected={({ item }) => {
        if (isPresenceOperator(item.value)) {
          presence?.setOperator(item.value);
        } else {
          setOperator(item.value);
        }
      }}
      selectedItem={options.find(
        (item) => item.value === (presence?.operator ?? operator),
      )}
      size="xs"
    />
  );
}
